import { BrandJusIa } from '@farol-ds/react'

import styles from './static-chat-topbar.module.scss'

export function StaticChatTopbar() {
  return (
    <div className={styles.container}>
      <BrandJusIa width={72} height={22} />
    </div>
  )
}
